/**
 * Configuración única de CKEditor para todo el proyecto.
 *
 * Antes esto estaba DUPLICADO en 7 componentes (5 copias idénticas y 2 variantes),
 * así que añadir un botón obligaba a tocar seis ficheros. Ahora hay una sola fuente.
 *
 * ⚠️ Método de instalación nuevo (CKEditor v42+): todo se importa del paquete
 * `ckeditor5` y NO de los `@ckeditor/ckeditor5-*` sueltos. Mezclar los dos orígenes
 * carga dos copias del núcleo y el editor muere con `ckeditor-duplicated-modules`.
 * El interlineado es propio (./ckeditor/LineHeight): el oficial de CKEditor es una
 * función de pago y con la licencia gratuita el editor ni siquiera arranca.
 */
import {
    ClassicEditor,
    Autoformat,
    BlockQuote,
    Bold,
    Essentials,
    Heading,
    Indent,
    Italic,
    Link,
    List,
    Paragraph,
    PasteFromOffice,
    Table,
    TableToolbar,
} from 'ckeditor5';
// Plugin PROPIO: el oficial de CKEditor es premium y con licencia GPL el editor
// se niega a arrancar (license-key-feature-not-allowed). Ver ckeditor/LineHeight.js.
import LineHeight from './ckeditor/LineHeight';

import 'ckeditor5/ckeditor5.css';

export { ClassicEditor };

/**
 * Desde la v44 CKEditor EXIGE una clave; 'GPL' es la del uso libre. Sin esto el
 * editor no arranca (no es un aviso, es un fallo duro).
 */
const LICENSE_KEY = 'GPL';

const PLUGINS = [
    Essentials,
    Paragraph,
    Heading,
    Bold,
    Italic,
    Link,
    List,
    Indent,
    BlockQuote,
    Table,
    TableToolbar,
    Autoformat,
    PasteFromOffice,
    LineHeight,
];

/**
 * Opciones de interlineado. Son multiplicadores de la altura de línea; el valor por
 * defecto se hereda del CSS, por eso 'default' va primero.
 */
const LINE_HEIGHT = {
    options: ['default', 1, 1.15, 1.5, 2, 2.5, 3],
};

/** Barra completa: descripciones, enunciados y explicaciones. */
export const editorConfig = {
    licenseKey: LICENSE_KEY,
    plugins: PLUGINS,
    toolbar: {
        items: [
            'undo', 'redo', '|',
            'heading', '|',
            'bold', 'italic', '|',
            'lineHeight', '|',
            'bulletedList', 'numberedList', '|',
            'insertTable', 'link',
        ],
    },
    lineHeight: LINE_HEIGHT,
    table: {
        contentToolbar: ['tableColumn', 'tableRow', 'mergeTableCells'],
    },
};

/** Barra reducida para las respuestas: son textos de una o dos líneas. */
export const editorConfigSimple = {
    licenseKey: LICENSE_KEY,
    plugins: PLUGINS,
    toolbar: {
        items: [
            'undo', 'redo', '|',
            'bold', 'italic', '|',
            'lineHeight', '|',
            'link',
        ],
    },
    lineHeight: LINE_HEIGHT,
};
